import { createFileRoute } from "@tanstack/react-router";
import { TagsSettingsPage } from "~/pages/TagsSettingsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/tags")({
  component: RouteComponent,
});

function RouteComponent() {
  return <TagsSettingsPage />;
}
